class DetailsModal extends HTMLElement {
  static instances = [];
  constructor() {
    super(),
      (this.header = document.querySelector(".header-wrapper")),
      (this.detailsContainer = this.querySelector("details")),
      (this.summaryToggle = this.querySelector("summary")),
      (this.closeButton = this.querySelector(".modal-close-button")),
      (this.header.preventHide = !1),
      this.detailsContainer.addEventListener(
        "keyup",
        (e) => "Escape" === e.code && this.close()
      ),
      this.summaryToggle.addEventListener(
        "click",
        this.onSummaryClick.bind(this)
      ),
      this.summaryToggle.setAttribute("role", "button"),
      this.closeButton &&
        this.closeButton.addEventListener("click", () => this.close()),
      DetailsModal.instances.push(this);
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(e) {
    e.preventDefault(),
      e.target.closest("details").hasAttribute("open")
        ? (this.close(), (this.header.preventHide = !1))
        : (this.open(e),
          this.header &&
            (this.header.preventHide = this.detailsContainer.open));
  }
  onBodyClick(e) {
    this.contains(e.target) || this.close(!1);
  }
  open(e) {
    DetailsModal.instances.forEach((e) => {
      e.isOpen() && e.close(!1);
    }),
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
      e.target.closest("details").setAttribute("open", !0),
      document.body.addEventListener("click", this.onBodyClickEvent),
      !this.classList.contains("header__search") &&
        document.body.classList.add("modal-open"),
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      ),
      this.header.parentNode.classList.contains("color-background-overlay") &&
        this.classList.contains("header__search") &&
        (this.header.parentNode.classList.remove("color-background-overlay"),
        this.header.parentNode.classList.add(
          "color-background-overlay-hidden"
        ));
  }
  close(e = !0) {
    removeTrapFocus(e ? this.summaryToggle : null),
      this.detailsContainer.removeAttribute("open"),
      document.body.removeEventListener("click", this.onBodyClickEvent),
      document.body.classList.remove("modal-open"),
      (this.header.preventHide = !1),
      this.header.parentNode.classList.contains(
        "color-background-overlay-hidden"
      ) &&
        this.classList.contains("header__search") &&
        (this.header.parentNode.classList.remove(
          "color-background-overlay-hidden"
        ),
        this.header.parentNode.classList.add("color-background-overlay"));
  }
}
customElements.define("details-modal", DetailsModal);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      document.addEventListener("keyup", this.onKeyUp.bind(this)),
      document.addEventListener("click", this.onFocusOut.bind(this));
  }
  onKeyUp(e) {
    "Escape" === e.code &&
      (this.mainDetailsToggle.removeAttribute("open"),
      document.body.classList.remove("overflow-hidden"));
  }
  onFocusOut(e) {
    e.composedPath().includes(this.mainDetailsToggle) ||
      this.mainDetailsToggle.removeAttribute("open");
  }
  close() {
    this.mainDetailsToggle.removeAttribute("open"),
      document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
